import { RootState } from 'data';
import { ResourceSection } from 'data/documents';
import { ProjectTemplateTask } from 'data/templates/projects';
import {
  DocumentTemplate,
  DocumentTemplateContentSection,
  DocumentTemplateStore,
} from './types';

export const selectDocumentById =
  (docId: number) =>
  ({ templates }: RootState): DocumentTemplate =>
    templates.document[docId]?.template;

export const selectSections =
  (docId: number, sectionIds: number[]) =>
  ({ templates }: RootState): DocumentTemplateContentSection[] => {
    return sectionIds.map((sectionId) => {
      return templates.document[docId]?.sections[sectionId];
    });
  };

export const selectResourceSections =
  (docId: number, resourceSectionIds: number[]) =>
  ({
    templates,
  }: RootState): ResourceSection<Partial<ProjectTemplateTask>>[] => {
    return resourceSectionIds.map((resourceSectionId) => {
      return templates.document[docId]?.resourceSections[resourceSectionId];
    });
  };
export const selectResourceSectionById =
  (docId: number, resourceSectionId: number) =>
  ({
    templates,
  }: RootState): ResourceSection<Partial<ProjectTemplateTask>> | undefined => {
    return templates.document[docId]?.resourceSections[resourceSectionId];
  };

export const selectAllDocumentResourceSections =
  (docId: number) =>
  ({
    templates,
  }: RootState): ResourceSection<Partial<ProjectTemplateTask>>[] => {
    return Object.values(templates.document[docId]?.resourceSections || {});
  };

export const getDocumentById =
  (id: number) =>
  ({ templates }: RootState): DocumentTemplate | undefined =>
    templates.document[id]?.template;

export const getDocumentTemplateStore =
  (id: number) =>
  ({ templates }: RootState): ValueOf<DocumentTemplateStore> | undefined =>
    templates.document[id];
